import React from "react";

export const LastSphere: React.FC = () => {
  return (
    <div className="w-full h-full overflow-hidden">
      <iframe
        src="/game/index.html"
        title="Last Sphere"
        className="w-full h-full border-0"
      />
    </div>
  );
};

export default LastSphere;